var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"quote"},[_vm._v(" "+_vm._s(_vm.quote.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }